import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-media_all",
  "use": "icon-media_all-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-media_all\"><defs><style>#icon-media_all .a{fill:none;}#icon-media_all .b{fill:#505d6f;}</style></defs><path class=\"a\" d=\"M0,0H24V24H0Z\" /><path class=\"b\" d=\"M21,3a1,1,0,0,1,1,1V20a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V4A1,1,0,0,1,3,3ZM20,5H4V19H20ZM13,17V15h3V12h2v5ZM11,7V9H8v3H6V7Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol